// dependencies
import React from "react";

// components
import FilterChips, { type Filter } from "../../../../../../../components/FilterChips/FilterChips";

// types
import type { ReviewCycleFilter } from "../ReviewCyclesFilters";

const convertFiltersToReadableList = (filters?: ReviewCycleFilter) => {
	const readableList: Filter[] = [];

	const filterKeyLookup = {
		automation_status: {
			id: "automation_status",
			type: "string",
			label: "Type",
			valueLabelMap: {
				automated: "Automated Review Cycles",
				"non-automated": "Non-Automated Review Cycles",
			},
		},
		status: {
			id: "status",
			type: "string",
			label: "Status",
		},
		reviews360: {
			id: "reviews360",
			type: "string",
			label: "360 Reviews",
			value: "Enabled",
		},
	};

	if (filters) {
		for (const filterKey in filters) {
			// Get applied filter value
			const filterValue = filters[filterKey];

			// Lookup the label for the filter value if applicable
			const valueLabel = filterKeyLookup[filterKey].valueLabelMap
				? filterKeyLookup[filterKey].valueLabelMap[filterValue]
				: filterValue;

			readableList.push({
				value: valueLabel,
				...filterKeyLookup[filterKey],
			});
		}
	}

	return readableList;
};

type ReviewCycleReadableFiltersListProps = {
	filters: ReviewCycleFilter;
	setFilters: (newFilters) => void;
};

const ReviewCycleReadableFiltersList = ({ filters, setFilters }: ReviewCycleReadableFiltersListProps) => {
	const convertedFilters = convertFiltersToReadableList(filters);

	if (convertedFilters.length === 0) {
		return null;
	}

	return (
		<div>
			<FilterChips
				filters={convertedFilters}
				label="Filters applied: "
				onDeleteFilter={(id) => {
					filters[id] = undefined;
					setFilters(filters);
				}}
			/>
		</div>
	);
};

export default ReviewCycleReadableFiltersList;
